import { FormHelperText, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import './AddExcelFilePopUp.scss';
import Button from '../../Buttons/Button';
import UploadFileButton from '../../Buttons/UploadFileButton/UploadFileButton';
import DescriptionIcon from '@material-ui/icons/Description';
import ClearIcon from '@material-ui/icons/Clear';
import Input from '../../InputFields/Input';
import { ADD, CANCEL } from '../../../../constants/translations/review-popup';
import { POP_UPS_TRANSLATION } from '../../../../constants/translations/customer/PopUps/PopUps';
import { DESKTOP_VIEW_TRANSLATION } from '../../../../constants/translations/customer/desktop/desktopView';
import moment from 'moment';
import { SmallLoader } from '../../../reused-components/SmallLoader';
import { FILE_ERRORS } from '../../../../constants/translations/customer/errors/errorMessage';
import { useDispatch } from 'react-redux';
import { systemActionsCreator } from '../../../../actions/customer/systemActions';
import * as XLSX from 'xlsx';
import { generalPostRequest } from '../../../../functions/api/general';
import Loader from '../../../LoaderNew/Loader';
const add = {
    name: ADD,
    width: '35%',
    height: '52px',
    color: '#fff',
    backgroundColor: "#0091FF",
    fontSize: '16px',
    fontWeight: 800,
    icon: false,
    iconContainer: false,
    border: false,
    isBoxShadow: true,
    borderRadius: '20px',
};

const cancel = {
    name: CANCEL,
    width: '35%',
    height: '52px',
    backgroundColor: '#fff',
    color: "#6C7389",
    fontSize: '16px',
    fontWeight: 800,
    icon: false,
    iconContainer: false,
    border: true,
    isBoxShadow: true,
    borderRadius: '20px',
};

const fileTabBtnsTablet = {
    add: {
        ...add,
        width: '35%',
        backgroundColor: "#0091FF",
        fontSize: '24px',
        height: '70px',
        borderRadius: '90px',
    },
    cancel: {
        ...cancel,
        name: CANCEL,
        width: '35%',
        fontSize: '24px',
        height: '70px',
        borderRadius: '90px',
    }
};

export default function AddExcelFilePopUp(props) {
    const { handleShowPopUp, showPopUp, name, view, customerId, customerName, updateFilesList, mode } = props;
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [pending, setPending] = useState(false);
    const [fileData, setFileData] = useState(null);
    const [jsonData, setJsonData] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (showPopUp) {
            setFile(null);
            setJsonData(null);
            setFileData(null);
        }
    }, [showPopUp]);

    const [inputValue, setInputValue] = useState({
        fileName: '',
        fileNameError: false,
        fileError: false
    });

    const targetHeaders = [
        'פתח',
        'מיקום',
        'סוג חלון',
        'גובה',
        'רוחב',
        'משקוף',
        'רשת',
        'מספר כנפיים',
        'תריס',
        'מנוע',
        'אופן ארט',
        'מובילים',
        'זוית גומי',
        "מס' ידיות",
        'נלווים לשטח',
        'הערות'
    ];

    const handleFileUpload = async (e) => {
        const uploadedFile = e.name ? e : e.target.files[0];
        if (!uploadedFile) return;

        const fileName = uploadedFile.name;
        const fileExtension = fileName.split('.').pop().toLowerCase();

        if (!['xlsx', 'xls', 'csv'].includes(fileExtension)) {
            setInputValue(prev => ({
                ...prev,
                fileError: true
            }));
            return;
        }

        setFile(fileName);
        setPending(true);

        try {
            const reader = new FileReader();

            reader.onload = (event) => {
                try {
                    const data = event.target.result;
                    const workbook = XLSX.read(data, { type: "binary" });
                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];

                    const allData = XLSX.utils.sheet_to_json(worksheet, {
                        header: 1,
                        defval: null
                    });

                    // --- Your real table header ---
                    const targetHeaders = [
                        'פתח',
                        'מיקום',
                        'סוג חלון',
                        'גובה',
                        'רוחב',
                        'משקוף',
                        'רשת',
                        'מספר כנפיים',
                        'תריס',
                        'מנוע',
                        'אופן ארט',
                        'מובילים',
                        'זוית גומי',
                        "מס' ידיות",
                        'נלווים לשטח',
                        'הערות'
                    ];

                    // 1️⃣ Locate header row of the target table only
                    let headerRowIndex = -1;
                    for (let i = 0; i < allData.length; i++) {
                        const row = allData[i];
                        const match = targetHeaders.some(h =>
                            row.some(c => c && c.toString().trim() === h)
                        );
                        if (match) {
                            headerRowIndex = i;
                            break;
                        }
                    }

                    if (headerRowIndex === -1) {
                        setInputValue(prev => ({ ...prev, fileError: true }));
                        setPending(false);
                        return;
                    }

                    const headers = allData[headerRowIndex];
                    const dataRows = allData.slice(headerRowIndex + 1);

                    // 2️⃣ Detect merged (colspan) headers using sheet merges
                    const merges = worksheet["!merges"] || [];
                    const colspanHeaders = {};

                    merges.forEach(m => {
                        if (m.s.r !== headerRowIndex) return; // only header row

                        const start = m.s.c;
                        const end = m.e.c;

                        const headerName = headers[start]?.toString().trim();
                        if (!headerName) return;

                        colspanHeaders[headerName] = [];
                        for (let c = start; c <= end; c++) {
                            colspanHeaders[headerName].push(c);
                        }
                    });

                    // 3️⃣ For headers without merges → assign single index
                    headers.forEach((h, colIndex) => {
                        if (!h) return;
                        const title = h.toString().trim();

                        if (!colspanHeaders[title]) {
                            colspanHeaders[title] = [colIndex];
                        }
                    });

                    // Helper: resolve merged cell value
                    function resolveCell(row, rowIndex, colIndex) {
                        if (row[colIndex] !== null && row[colIndex] !== undefined) {
                            return row[colIndex];
                        }
                        for (const m of merges) {
                            if (
                                m.s.r <= rowIndex &&
                                m.e.r >= rowIndex &&
                                m.s.c <= colIndex &&
                                m.e.c >= colIndex
                            ) {
                                return row[m.s.c] ?? null;
                            }
                        }
                        return null;
                    }
                    // 4️⃣ Parse rows belonging to this table only
                    const parsedRows = dataRows
                        .filter(r => {
                            const col2 = r[1];

                            // ❌ Ignore row if second column is empty
                            if (col2 === null || col2 === undefined || col2 === "") {
                                return false;
                            }

                            // ✔ Otherwise process normally
                            return r.some(c => c !== null && c !== "");
                        })
                        .map((r, idx) => {
                            const obj = {};
                            const absoluteRow = headerRowIndex + 1 + idx;

                            Object.entries(colspanHeaders).forEach(([headerName, columns]) => {
                                if (columns.length > 1) {
                                    obj[headerName] = columns.map(col =>
                                        resolveCell(r, absoluteRow, col)
                                    );
                                } else {
                                    obj[headerName] = resolveCell(r, absoluteRow, columns[0]);
                                }
                            });

                            return obj;
                        });


                    const finalData = {
                        colspanMap: colspanHeaders,
                        rows: parsedRows
                    };

                    setJsonData(finalData);
                    setFileData(finalData);
                    updateFilesList && updateFilesList(finalData);
                    setPending(false);

                } catch (error) {
                    console.error("❌ ERROR:", error);
                    setInputValue(prev => ({ ...prev, fileError: true }));
                    setPending(false);
                }
            };

            reader.onerror = () => {
                console.error('Error reading file');
                setInputValue(prev => ({
                    ...prev,
                    fileError: true
                }));
                setPending(false);
            };

            reader.readAsBinaryString(uploadedFile);
        } catch (error) {
            console.error('Error processing file:', error);
            setPending(false);
        }
    };

    const validation = ({ name, value }) => {
        let _isValid = true;
        const errors = {};

        if (name === 'fileName' || typeof name === 'undefined') {
            const isValid = isFileNameValid(value || inputValue.fileName);
            errors.fileNameError = !isValid;
            _isValid = isValid;
        }

        if (typeof name === 'undefined') {
            const isValid = isFileValid();
            errors.fileError = !isValid;
            _isValid = isValid;
        }

        setInputValue((prev) => ({
            ...prev,
            ...errors
        }));
        return _isValid;
    };

    const isFileNameValid = (value) => {
        if (value.length < 3) {
            return false;
        }
        return true;
    };

    const isFileValid = () => {
        if (!file || !jsonData) {
            return false;
        }
        return true;
    };

    let todayDate = moment(new Date()).format("DD/MM/YYYY");

    const submitForm = async () => {
        if (!validation({})) {
            return;
        }

        if (fileData && jsonData) {
            try {
                setIsLoading(true);
                let response = await handleUploadSystem({
                    "customer_id": props.customerId,
                    systems_data: jsonData.rows
                })
                if (response && response.ok === true) {
                    dispatch(systemActionsCreator.getSystemsByCustomer(response.result.customer));
                } else if (response.ok === false) {
                    console.error('An error occurred in handleAddSystem:', response.error, response.message);
                }
            } catch (error) {
                console.error('An error occurred in handleAddSystem:', error);
                // Handle exception appropriately
            } finally {
                setIsLoading(false); // Stop loader
            }
        }

        handleShowPopUp();
    };

    const handleUploadSystem = async (systemBody) => {
        let response = await generalPostRequest(systemBody, `/system/customer-page/upload-system-data`)
        return response;
    }

    const handleChange = (name, value) => {
        if (inputValue[`${name}Error`]) {
            validation({ name, value });
        }
        setInputValue((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const excelFileInputs = {
        fileName: {
            label: 'Excel File Name',
            placeholder: POP_UPS_TRANSLATION.ENTER,
            value: inputValue.fileName,
            type: 'text',
            name: 'fileName',
            onChange: handleChange,
            error: inputValue.fileNameError,
            errorText: inputValue.fileNameError && FILE_ERRORS.FILE_NAME_REQUIRED
        }
    };

    if (!showPopUp) return null;

    return (
        <div className='popUp__background'>
            <Grid className={`${view === 'tablet' && 'addExcelFilePopUp__main--tablet'} addExcelFilePopUp__main`}
                style={{
                    width: view === 'tablet' ? '700px' : view === 'desktop' && '580px',
                    height: view === 'desktop' && '650px'
                }}>
                <Grid>
                    <h4 className={`${view === 'tablet' && 'addExcelFilePopUp__name--tablet'} addExcelFilePopUp__name`}>
                        {name || 'Upload Excel File'}
                    </h4>
                </Grid>

                <Grid className='addExcelFilePopUp__uploadedInfo__main'>
                    <Grid xs={12} className={`${view === 'tablet' ? 'addExcelFilePopUp__uploadedInfo__container--tablet' : ''} addExcelFilePopUp__uploadedInfo__container`}>
                        <Grid item xs={6} className={`${view === 'tablet' ? 'addExcelFilePopUp__uploadedInfo__label--tablet' : ''} addExcelFilePopUp__uploadedInfo__label`}>
                            <span>{POP_UPS_TRANSLATION.UPLOADED_BY}</span>
                        </Grid>
                        <Grid item xs={6} className={`${view === 'tablet' ? 'addExcelFilePopUp__uploadedInfo__value--tablet' : ''} addExcelFilePopUp__uploadedInfo__value`}>
                            <span>{customerName || POP_UPS_TRANSLATION.ZAIN_BATOR}</span>
                        </Grid>
                    </Grid>
                    <Grid xs={12} className='addExcelFilePopUp__uploadedInfo__container'>
                        <Grid item xs={6} className={`${view === 'tablet' ? 'addExcelFilePopUp__uploadedInfo__label--tablet' : ''} addExcelFilePopUp__uploadedInfo__label`}>
                            <span>{POP_UPS_TRANSLATION.UPLOADED_DATE}</span>
                        </Grid>
                        <Grid item xs={6} className={`${view === 'tablet' ? 'addExcelFilePopUp__uploadedInfo__value--tablet' : ''} addExcelFilePopUp__uploadedInfo__value`}>
                            <span>{todayDate}</span>
                        </Grid>
                    </Grid>
                </Grid>

                <div className='addExcelFilePopUp__fileInfo'>
                    <p>Accepted formats: .xlsx, .xls, .csv</p>
                    <p>Maximum file size: 10MB</p>
                </div>

                <div className='errorAttachmentContainer'>
                    {inputValue.fileError && (
                        <FormHelperText className='inputAttachmentError'>
                            {FILE_ERRORS.FILE_ATTACHMENT_REQUIRED || 'Please upload a valid Excel file (.xlsx, .xls, .csv)'}
                        </FormHelperText>
                    )}
                </div>

                {view === 'desktop' ? (
                    <Grid sx={12} className='addExcelFilePopUp__textArea__container'>
                        {pending ? (
                            <SmallLoader />
                        ) : file && jsonData ? (
                            <UploadedExcelPreview
                                handelClearFile={() => {
                                    setFile(null);
                                    setJsonData(null);
                                    setFileData(null);
                                }}
                                view={view}
                                file={file}
                                jsonData={jsonData}
                            />
                        ) : (
                            <div className='addExcelFilePopUp__textArea__label'>
                                <UploadFileButton handleFileUpload={handleFileUpload} view="desktop" accept=".xlsx,.xls,.csv" />
                                <span>{DESKTOP_VIEW_TRANSLATION.DRAG_AND_DROP_YOUR_FILE_HERE_OR || 'Drag and drop your Excel file here or'}</span>
                            </div>
                        )}
                    </Grid>
                ) : file && jsonData ? (
                    <UploadedExcelPreview
                        handelClearFile={() => {
                            setFile(null);
                            setJsonData(null);
                            setFileData(null);
                        }}
                        view={view}
                        file={file}
                        jsonData={jsonData}
                    />
                ) : (
                    <Grid sx={12} className={`${view === 'tablet' && 'addExcelFilePopUp__uploadBtn__container--tablet'} addExcelFilePopUp__uploadBtn__container`}>
                        <UploadFileButton handleFileUpload={handleFileUpload} view={view} accept=".xlsx,.xls,.csv" />
                    </Grid>
                )}

                {isLoading ? <Loader /> : view === 'desktop' ? (
                    <Grid sx={12} className='addExcelFilePopUp__btn__container addExcelFilePopUp__btn--desktop'>
                        <Button data={add} handleClick={() => submitForm()} />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Button data={cancel} handleClick={() => handleShowPopUp()} />
                    </Grid>
                ) : view === 'tablet' ? (
                    <Grid sx={12} className='addExcelFilePopUp__btn__container'>
                        <Button data={fileTabBtnsTablet.add} handleClick={() => submitForm()} />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Button data={fileTabBtnsTablet.cancel} handleClick={() => handleShowPopUp()} />
                    </Grid>
                ) : null}
            </Grid>
        </div>
    );
}

export const UploadedExcelPreview = ({ handelClearFile, view, file, jsonData }) => {
    const [showJson, setShowJson] = useState(false);

    return (
        <div className={view === 'desktop' && 'addExcelFilePopUp__uploaded--position'}>
            <Grid xs={12} className={view === 'desktop' ? 'addExcelFilePopUp__uploaded__container--desktop' : 'addExcelFilePopUp__uploaded__container'}>
                {view !== 'desktop' && <label>{POP_UPS_TRANSLATION.UPLOADED_FILE || 'Uploaded File'}</label>}
                <Grid xs={12} className={view === 'desktop' ? 'addExcelFilePopUp__uploaded__infoContainer--desktop' : 'addExcelFilePopUp__uploaded__infoContainer'}>
                    <Grid xs={10} className={view === 'desktop' ? 'addExcelFilePopUp__nameType--desktop' : 'addExcelFilePopUp__nameType'}>
                        <span className={view === 'desktop' ? 'addExcelFilePopUp__icon__container-doc--desktop' : 'addExcelFilePopUp__icon__container'}>
                            <DescriptionIcon style={{ fontSize: view === 'desktop' ? '18px' : view === 'tablet' ? '24px' : '16px' }} />
                        </span>
                        &nbsp;
                        <label>{file}</label>
                    </Grid>
                    <Grid xs={2} className='addExcelFilePopUp__remove'>
                        <span
                            className={view === 'desktop' ? 'addExcelFilePopUp__icon__container--desktop' : 'addExcelFilePopUp__icon__container'}
                            onClick={() => handelClearFile()}
                        >
                            <ClearIcon style={{ fontSize: view === 'desktop' ? '18px' : view === 'tablet' ? '24px' : '16px' }} />
                        </span>
                    </Grid>
                </Grid>

                {/* JSON Data Preview Section */}
                <div style={{ marginTop: '15px', width: '100%' }}>
                    {/* Rows Count */}
                    <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                        <p>Total rows extracted: <strong>{jsonData?.rows?.length || 0}</strong></p>
                    </div>
                </div>
            </Grid>
        </div>
    );
};